// extracted by mini-css-extract-plugin
export var drawerPaper = "_3l-0";
export var itemCard = "_3l-1";
export var itemImage = "_3l-2";